import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TaskNotificationService } from '../../services/task-notification.service';
import { pairwise, startWith, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-task-notification-bar',
  standalone: true,
  imports: [
    AsyncPipe,
    NgFor,
    NgIf,
    NgClass,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './task-notification-bar.component.html',
  styleUrl: './task-notification-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskNotificationBarComponent implements OnInit, OnDestroy {
  readonly taskService = inject(TaskNotificationService);
  readonly tasks$ = this.taskService.tasks$;
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() isRightMenuActive = false;

  isOpen = false;

  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.tasks$
      .pipe(
        startWith([]),
        pairwise(),
        takeUntil(this.destroy$)
      )
      .subscribe(([prevTasks, currentTasks]) => {
        if (currentTasks.length > prevTasks.length) {
          this.isOpen = true;
          this.cdr.markForCheck();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  togglePanel(): void {
    this.isOpen = !this.isOpen;
    this.cdr.markForCheck();
  }

  removeTask(id: string): void {
    this.taskService.removeTask(id);
  }

  clearFinished(): void {
    this.taskService.clearFinished();
  }

  trackByTaskId(_: number, task: { id: string }): string {
    this.isOpen = true;
    return task.id;
  }
}
